// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useMutation } from '@tanstack/react-query';
import { useChangePasswordApi } from '../../hooks/useChangePasswordApi';
import { ChangeUserPasswordUserTypeEnum } from '../../client-sdk/api';


export const useChangePassword = () => {
//   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { changePassword } = useChangePasswordApi();

  return useMutation({
    mutationKey: ['ChangePassword'],
    mutationFn: ({ id, userType, data }: { id: string; userType: ChangeUserPasswordUserTypeEnum; data: any }) =>
      changePassword(id, userType, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Password Updated successfully',
        'success'
      );
    //   queryClient.invalidateQueries({
    //     queryKey: ['getChoiceGroup'],
    //     exact: false,
    //   });
    },
    onError: (error: any) => {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message;
      showMessage(apiMessage || 'Failed to update password', 'error');
    },
  });
};
